var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideoIconDisabled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 53 53",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 19h9a4 4 0 014 4v7.8a4 4 0 01-4 4h-9a4 4 0 01-4-4V23a4 4 0 014-4zm15.452 4.968l3.36-2.198a1 1 0 011.548.836v8.28a1 1 0 01-1.489.873l-3.36-1.88a1 1 0 01-.511-.873v-4.201a1 1 0 01.452-.837z",
    fill: "#3C4C60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.599 15.752L34.657 34.57a1.115 1.115 0 01-.043 1.628l-.05.044a1.2 1.2 0 01-1.64-.044l-19.08-18.863a1.073 1.073 0 01.07-1.59l.076-.063a1.2 1.2 0 011.609.07z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.111 16.698l19.92 19.818a.95.95 0 01-.017 1.363 1.007 1.007 0 01-1.403-.017L12.642 17.973a.904.904 0 01.046-1.323 1.046 1.046 0 011.423.048z",
    fill: "#3C4C60"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIconDisabled);
export default __webpack_public_path__ + "static/media/VideoIconDisabled.f97250eb149e6201b2e870ecec0af08c.svg";
export { ForwardRef as ReactComponent };